<style scoped lang="scss">
.circle {
  border-radius: 100%;
  background-color: $danger;
  transition: background-color 0.3s linear;
  height: 25px;
  width: 25px;
  margin-left: 10px;

  &--online {
    background-color: $green;
  }
}
</style>

<template>
  <td class="text-center text-lg">
    <div class="circle" :class="{ 'circle--online': online }"></div>
  </td>
</template>

<script lang="babel">
export default {
  props: {
    content: {
      required: true,
      type: Number,
    }
  },
  computed: {
    online() {
      return this.$store.getters["online/profileOnline"](this.content);
    }
  }
};
</script>
